import { getBackbone } from '@/library/http';

export const getRegistrationEnvironments = async (
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  id: string,
  registrationId: string,
  digitalService: string,
  infraService: string,
  status: string,
  environment: string,
  dateFrom: string,
  dateTo: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  if (sortBy?.length) filter += `&orderBy=${sortBy}`;
  if (id?.length) filter += `&id=${id}`;
  if (registrationId?.length) filter += `&registrationId=${registrationId}`;
  if (digitalService?.length) filter += `&digitalService=${digitalService}`;
  if (infraService?.length) filter += `&infraService=${infraService}`;
  if (environment?.length) filter += `&environment=${environment}`;
  if (status?.length && status === 'removed') filter += `&deleted=true`;
  if (status?.length && status !== 'removed') filter += `&status=${status}`;
  if (dateFrom?.length) filter += `&from=${dateFrom}`;
  if (dateTo?.length) filter += `&to=${dateTo}`;

  return getBackbone(`/registration-environments/?limit=${limit}&skip=${skip}${filter}`);
};

export const getZones = async (
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  id: string,
  registrationId: string,
  digitalService: string,
  infraService: string,
  changeNumber: string,
  status: string,
  name: string,
  license: string,
  dns_enabled: boolean | undefined,
  dateFrom: string,
  dateTo: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  if (sortBy?.length) filter += `&orderBy=${sortBy}`;
  if (id?.length) filter += `&id=${id}`;
  if (registrationId?.length) filter += `&registrationId=${registrationId}`;
  if (digitalService?.length) filter += `&digitalService=${digitalService}`;
  if (infraService?.length) filter += `&infraService=${infraService}`;
  if (changeNumber?.length) filter += `&change_number=${changeNumber}`;
  if (name?.length) filter += `&name=${name}`;
  if (license?.length) filter += `&license=${license}`;
  if (status?.length && status === 'removed') filter += `&deleted=true`;
  if (status?.length && status !== 'removed') filter += `&status=${status}`;
  if (dateFrom?.length) filter += `&from=${dateFrom}`;
  if (dateTo?.length) filter += `&to=${dateTo}`;

  if (dns_enabled !== undefined) {
    filter += `&dns_enabled=${dns_enabled}`;
  }

  return getBackbone(`/cloudflare-zones/?limit=${limit}&skip=${skip}${filter}`);
};

export const getFirewallRules = async (
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  id: string,
  registrationId: string,
  infraService: string,
  changeNumber: string,
  status: string,
  sourceIp: string,
  targetIp: string,
  sourceApmId: string,
  targetApmId: string,
  sourceServiceName: string,
  targetServiceName: string,
  sourceEnv: string,
  targetEnv: string,
  sourceDatacenter: string,
  targetDatacenter: string,
  port: string,
  protocol: string,
  dateFrom: string,
  dateTo: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  if (sortBy?.length) filter += `&orderBy=${sortBy}`;
  if (id?.length) filter += `&id=${id}`;
  if (registrationId?.length) filter += `&registrationId=${registrationId}`;
  if (infraService?.length) filter += `&infraService=${infraService}`;
  if (changeNumber?.length) filter += `&last_change_number=${changeNumber}`;
  if (sourceIp?.length) filter += `&source_ip=${sourceIp}`;
  if (targetIp?.length) filter += `&target_ip=${targetIp}`;
  if (sourceApmId?.length) filter += `&source_apm_id=${sourceApmId}`;
  if (targetApmId?.length) filter += `&target_apm_id=${targetApmId}`;
  if (sourceServiceName?.length) filter += `&source_service_name=${sourceServiceName}`;
  if (targetServiceName?.length) filter += `&target_service_name=${targetServiceName}`;
  if (sourceEnv?.length) filter += `&source_env=${sourceEnv}`;
  if (targetEnv?.length) filter += `&target_env=${targetEnv}`;
  if (sourceDatacenter?.length) filter += `&source_datacenter=${sourceDatacenter}`;
  if (targetDatacenter?.length) filter += `&target_datacenter=${targetDatacenter}`;
  if (status?.length && status === 'removed') filter += `&deleted=true`;
  if (status?.length && status !== 'removed') filter += `&status=${status}`;
  if (port?.length) filter += `&port=${port}`;
  if (protocol?.length) filter += `&protocol=${protocol}`;
  if (dateFrom?.length) filter += `&from=${dateFrom}`;
  if (dateTo?.length) filter += `&to=${dateTo}`;

  return getBackbone(`/firewall-rules/?limit=${limit}&skip=${skip}${filter}`);
};

export const getDnsRecords = async (
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  scope: string,
  id: string,
  registrationId: string,
  digitalService: string,
  infraService: string,
  changeNumber: string,
  status: string,
  name: string,
  value: string,
  domain: string,
  type: string,
  dateFrom: string,
  dateTo: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  if (sortBy?.length) filter += `&orderBy=${sortBy}`;
  if (id?.length) filter += `&id=${id}`;
  if (scope?.length) filter += `&scope=${scope}`;
  if (registrationId?.length) filter += `&registrationId=${registrationId}`;
  if (digitalService?.length) filter += `&digitalService=${digitalService}`;
  if (infraService?.length) filter += `&infraService=${infraService}`;
  if (name?.length) filter += `&name=${name}`;
  if (changeNumber?.length) filter += `&change_number=${changeNumber}`;
  if (value?.length) filter += `&value=${value}`;
  if (domain?.length) filter += `&domain=${domain}`;
  if (type?.length) filter += `&type=${type}`;
  if (status?.length && status === 'removed') filter += `&deleted=true`;
  if (status?.length && status !== 'removed') filter += `&status=${status}`;
  if (dateFrom?.length) filter += `&from=${dateFrom}`;
  if (dateTo?.length) filter += `&to=${dateTo}`;

  return getBackbone(`/dns-records/?limit=${limit}&skip=${skip}${filter}`);
};

export const getAdfRecords = async (
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  id: string,
  registrationId: string,
  digitalService: string,
  environment: string,
  provider: string,
  status: string,
  objectId: string,
  dateFrom: string,
  dateTo: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  if (sortBy?.length) filter += `&orderBy=${sortBy}`;
  if (id?.length) filter += `&id=${id}`;
  if (registrationId?.length) filter += `&registrationId=${registrationId}`;
  if (digitalService?.length) filter += `&digitalService=${digitalService}`;
  if (environment?.length) filter += `&environment=${environment}`;
  if (provider?.length) filter += `&provider=${provider}`;
  if (status?.length && status === 'removed') filter += `&deleted=true`;
  if (status?.length && status !== 'removed') filter += `&status=${status}`;
  if (objectId?.length) filter += `&objectId=${objectId}`;
  if (dateFrom?.length) filter += `&from=${dateFrom}`;
  if (dateTo?.length) filter += `&to=${dateTo}`;

  return getBackbone(`/adf-records/?limit=${limit}&skip=${skip}${filter}`);
};
